/** The slice of a Shift that attribution reads — its forward link to the jobs it runs. */
export interface ShiftJobLinks {
	id: string;
	jobIds: readonly string[];
}

/** The slice of a Job that attribution reads — its reverse link back to its shift. */
export interface JobShiftLink {
	id: string;
	shiftId?: string;
}

/**
 * jobId → id of the shift the job is scheduled on.
 *
 * Attribution goes through the shifts' own `jobIds` (the forward link the portal owns) with the
 * job's `shiftId` reverse-link as fallback — runtime-assigned jobs may lack the reverse link
 * (offline fake; Airtable computes it asynchronously). When two shifts list the same job the first
 * one wins, so the answer is stable across calls. Jobs neither link names are absent from the map.
 */
export function shiftIdByJobId(shifts: readonly ShiftJobLinks[], jobs: readonly JobShiftLink[]): Map<string, string> {
	const result = new Map<string, string>();
	for (const shift of shifts) {
		for (const jobId of shift.jobIds) if (!result.has(jobId)) result.set(jobId, shift.id);
	}
	for (const job of jobs) {
		if (job.shiftId && !result.has(job.id)) result.set(job.id, job.shiftId);
	}
	return result;
}
